<mat-dialog-content>
  <h3>Kies een baan:</h3>
  @for (item of [].constructor(data.totalCourts); track $index) {
    <button type="button"
      class="btn {{ this.court == ($index + 1) ? 'btn-primary' : (data.availableCourts.indexOf($index + 1) < 0 ? 'btn-outline-secondary' : 'btn-outline-primary') }} btn-lg m-3"
      [disabled]="data.availableCourts.indexOf($index + 1) < 0"
      (click)="selectCourt($index + 1)">
      {{ $index + 1 }}
    </button>
  }
  <br>
  <h3>Kies een teller:</h3>
  <div class="col-md-6">
    <mat-form-field appearance="fill">
      <mat-label>Teller</mat-label>
      <mat-select [(ngModel)]="counter">
        <mat-option>Geen</mat-option>
        @for (player of data.availableCounters; track player.playerId) {
          <mat-option [value]="player">
            {{ player.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (court && counter) {
    <button mat-button [mat-dialog-close]="{court: court, counter: counter}">Wedstrijd starten</button>
  }
  <button mat-button (click)="onAnnulerenClick()">Annuleren</button>
</mat-dialog-actions>
